// 获取url中query参数
export function getUrlParam(param) {
  let query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == param) {
      return pair[1]
    }
  }
}

// 获取code
export function getCode() {
  return getUrlParam('code')
}